import React, { useState, useEffect, useRef } from 'react';
import EditHeader from '../EditHeader/EditHeader';
import SectionHeader from '../SectionHeader/SectionHeader';
import SelectNameAvatar from "./Step3/Step3";
import styles from "./EditNameAvtar.module.css";
import AnimatedButton from '../AnimatedButton/AnimatedButton';
import { useLocation, useNavigate } from 'react-router-dom';
import PopUp from '../Popup/Popup';
import { useDashboardStore } from '../../Store/agentZustandStore';
import { getUserAgentMergedDataForAgentUpdate, updateAgentFromBackend } from '../../Store/apiStore';
import api, { API_BASE_URL } from '../../Store/apiStore';
import { isPythonBackend, authHeaders } from '../../utils/apiBackend';

function EditNameAvtar() {
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const [popupMessage, setPopupMessage] = useState("");
  const [Loading, setLoading] = useState(true);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  // const agentVoice=

  const { agentId: stateAgentId, businessId: stateBusinessId, isChanged, isGender } = location.state || {};
  // console.log(isGender, "isGender")
  const { setHasFetched } = useDashboardStore();

  const agentnm = sessionStorage.getItem("agentName") || "";

  const originalAvatarRef = useRef(null);
  const originalNameRef = useRef(null);
  const originalRoleRef = useRef(null);
  const originalGreetingRef = useRef(null);
  // Default greeting ki lines isi naam se banti hain (Step3 ka Default card).
  const businessNameRef = useRef("");

  const [currentAvatar, setCurrentAvatar] = useState(null);
  const [currentName, setCurrentName] = useState("");
  const [currentRole, setCurrentRole] = useState("");
  const [currentGreeting, setCurrentGreeting] = useState("");

  const [stepValidation, setStepValidation] = useState({
    isDirty: isGender ? true : false,
    isValid: true,
  });

  useEffect(() => {
    if (isChanged || isGender) {
      setStepValidation((prev) => ({ ...prev, isDirty: true }));
    }
  }, [isChanged, isGender]);

  const handleValidationChange = (validation) => {
    // ✅ isGender aaya hai toh hamesha dirty true rakho
    const finalDirty = isGender ? true : validation.isDirty;
    const finalValid = validation.isValid !== undefined ? validation.isValid : true;
    setStepValidation({ isDirty: finalDirty, isValid: finalValid });
  };

  useEffect(() => {
    const fetchAgentData = async () => {

      const finalAgentId =
        stateAgentId ||
        sessionStorage.getItem("SelectAgentId") ||
        sessionStorage.getItem("agent_id");

      const finalBusinessId =
        stateBusinessId ||
        sessionStorage.getItem("SelectAgentBusinessId") ||
        sessionStorage.getItem("businessId") ||
        sessionStorage.getItem("bId");

      if (!finalAgentId || !finalBusinessId) {
        console.warn("⚠️ No agent IDs found - redirecting");
        navigate("/edit-agent-new");
        return;
      }
      // const originalAvatarRef = React.useRef(sessionStorage.getItem("avatar"));
      // const originalNameRef = React.useRef(sessionStorage.getItem("agentName"));
      // const originalRoleRef = React.useRef(sessionStorage.getItem("agentRole"));
      try {
        setLoading(true);

        const res = await getUserAgentMergedDataForAgentUpdate(finalAgentId, finalBusinessId);
        const agent = res?.data?.agent;

        if (!agent) throw new Error("No agent data received");

        // ✅ null rakho agar DB mein nahi hai — "" mat banao
        const avatar = agent?.avatar || null;
        const name = agent?.agentName || "Sophia";
        const gender = agent?.agentGender || agent?.gender || "";

        // Number assign ho ya plan free ke alawa koi ho -> General Receptionist, warna Sales Receptionist
        const plan = String(agent?.agentPlan || "").trim().toLowerCase();
        const isPaidPlan = plan && plan !== "free" && plan !== "demo";

        const v = agent?.voip_numbers;
        let hasAssignedNumber = false;
        if (v) {
          if (Array.isArray(v)) hasAssignedNumber = !!v[0];
          else if (typeof v === "string") {
            const t = v.trim();
            if (t && t !== "[]" && t !== "null") {
              if (t.startsWith("[")) {
                try {
                  const parsed = JSON.parse(t);
                  hasAssignedNumber = Array.isArray(parsed) ? !!parsed[0] : !!parsed;
                } catch {
                  hasAssignedNumber = true;
                }
              } else {
                hasAssignedNumber = true;
              }
            }
          }
        }

        // Pounce agent ka role wahi rehta hai — use Receptionist bhej dete to
        // save pe uska agentRole aur prompt dono receptionist ke ban jaate.
        const isPounce = String(agent?.agentRole || "").trim().toLowerCase() === "pounce";
        const role = isPounce
          ? agent.agentRole
          : (hasAssignedNumber || isPaidPlan)
            ? "General Receptionist"
            : "Sales Receptionist";

        // ✅ Session mein sirf valid values save karo
        if (avatar) {
          sessionStorage.setItem("avatar", avatar);
        } else {
          sessionStorage.removeItem("avatar"); // stale value clear karo
        }
        sessionStorage.setItem("agentName", name);
        sessionStorage.setItem("agentRole", role);
        if (gender) sessionStorage.setItem("agentGender", gender);
        if (isGender) {
          sessionStorage.setItem("agentGender", isGender); // isGender se override
        }

        // Default card ki teen lines isi naam se banti hain (Step3). Khaali
        // rahe to helper khud "our business" laga leta hai.
        const business = res?.data?.business || {};
        const effectiveBusinessName =
          business.businessName || sessionStorage.getItem("businessName") || "";

        /*
         * Khaali greeting ab "Default" hai — koi line pin nahi, backend khud
         * teen natural variations prompt me daalta hai. Pehle yahan ek synthetic
         * line bhar di jaati thi kyunki purani UI ka textarea required tha; ab
         * wo agent ko jhoothi "custom" greeting dikha deti, isliye hata di.
         */
        const greeting = agent?.customGreeting || "";

        sessionStorage.setItem("customGreeting", greeting);
        businessNameRef.current = effectiveBusinessName;
        // customGreeting ki tarah ye bhi har agent par refresh hona chahiye.
        // sessionStorage poore tab me shared hai — agent A ka "custom" wahan
        // pada reh jaata aur agent B ka edit screen usi ko padh leta.
        sessionStorage.setItem("greetingChoice", greeting ? "custom" : "default");

        // Baselines set karo
        originalAvatarRef.current = avatar;   // null ya actual value
        originalNameRef.current = name;
        originalRoleRef.current = role;
        originalGreetingRef.current = greeting;
        if (isGender) {
          originalAvatarRef.current = null;
          sessionStorage.removeItem("avatar")
        }
        setCurrentAvatar(avatar);
        setCurrentName(name);
        setCurrentRole(role);
        setCurrentGreeting(greeting);

        setStepValidation({ isDirty: isGender ? true : false });
        setIsDataLoaded(true);

      } catch (err) {
        console.error("❌ EditNameAvtar fetch error:", err);
        setPopupType("error");
        setPopupMessage("Failed to load agent data. Please try again.");
        setShowPopup(true);
      } finally {
        setLoading(false);
      }
    };

    fetchAgentData();
  }, [stateAgentId, stateBusinessId, navigate]);

  const handleClick = async () => {
    const avatar = sessionStorage.getItem('avatar');
    const name = sessionStorage.getItem('agentName');

    // ✅ Avatar select nahi ki toh rok do
    if (!avatar) {
      setPopupType("failed");
      setPopupMessage("Please select an Agent Avatar!");
      setShowPopup(true);
      return;
    }

    if (!name || name.trim().length === 0) {
      setPopupType("failed");
      setPopupMessage("Please enter an Agent Name!");
      setShowPopup(true);
      return;
    }

    // Greeting khaali hona valid hai — matlab "Default" chuna gaya hai.

    await saveChanges();
  };

  const saveChanges = async () => {
    if (!stepValidation.isDirty) return;

    try {
      setLoading(true);

      const finalAgentId =
        stateAgentId ||
        sessionStorage.getItem("SelectAgentId") ||
        sessionStorage.getItem("agent_id");

      // "0" | "1" | "2" = pre-built variant, "custom" = apni line. Poori greeting
      // customGreeting me hi jaati hai; ye sirf intent hai. Null tab hota hai jab
      // agent is column se pehle bana ho aur user ne greeting chhui na ho — us
      // case me field bheji hi nahi jaati, taaki backend column ko chhede na.
      const savedGreetingChoice = sessionStorage.getItem("greetingChoice");

      const payload = {
        agent_id: finalAgentId,
        agentAvatar: sessionStorage.getItem("avatar"),
        agentName: sessionStorage.getItem("agentName"),
        agentType: sessionStorage.getItem("agentRole"),
        agentGender: sessionStorage.getItem("agentGender"),
        customGreeting: sessionStorage.getItem("customGreeting"),
        isUpdatellm: true,
        ...(savedGreetingChoice != null && { greetingChoice: savedGreetingChoice }),
        ...(isGender && { agentVoice: sessionStorage.getItem("agentVoice") }),
      };

      // A Python agent has no Retell LLM, so Node's /updateAgent 500s
      // (get-retell-llm/null) and name/avatar never save. For Python:
      //   1) Node /updateAgentBusinessPython — saves agentName/avatar/role/voice
      //      to AgentsDetails ONLY (no Retell touch).
      //   2) Python /agents/{id}/edit — regenerates the prompt from the freshly
      //      saved data (the agent name lives in the prompt, exactly like Node's
      //      needsLLMUpdate path) and rebuilds the KB.
      // Node agent (isPythonBackend() false) → original updateAgentFromBackend.
      let res;
      if (isPythonBackend()) {
        const nodeRes = await api.patch(
          `${API_BASE_URL}/agentV2/updateAgentBusinessPython`,
          payload
        );
        await fetch(
          `${process.env.REACT_APP_PY_API_BASE_URL}/agents/${finalAgentId}/edit`,
          { method: "POST", headers: authHeaders() }
        );
        res = nodeRes?.data;
      } else {
        res = await updateAgentFromBackend(payload);
      }

      if (res?.success) {
        setPopupType("success");
        setPopupMessage("Agent name, avatar and greeting updated successfully!");
        setShowPopup(true);

        const newAvatar = sessionStorage.getItem("avatar");
        const newName = sessionStorage.getItem("agentName");
        const newRole = sessionStorage.getItem("agentRole");
        const newGreeting = sessionStorage.getItem("customGreeting");

        originalAvatarRef.current = newAvatar;
        originalNameRef.current = newName;
        originalRoleRef.current = newRole;
        originalGreetingRef.current = newGreeting;

        setCurrentAvatar(newAvatar);
        setCurrentName(newName);
        setCurrentRole(newRole);
        setCurrentGreeting(newGreeting);

        setStepValidation({ isDirty: isGender ? true : false });
        setHasFetched(false);
        sessionStorage.setItem("nextEditRoute", "/edit-agent-new");
        setTimeout(() => {
          navigate("/fast-agent-detail", { replace: true });
        }, 2000);


      } else {
        throw new Error(res?.message || "Update failed");
      }
    } catch (error) {
      console.error("❌ Save error:", error);
      setPopupType("error");
      setPopupMessage("Failed to update agent. Please try again.");
      setShowPopup(true);
    } finally {
      setLoading(false);
    }
  };

  if (Loading || !isDataLoaded) {
    return (
      <div>
        <EditHeader title='Edit Agent' agentName={agentnm} />
        <div style={{ textAlign: "center", padding: "50px" }}>
          <p>Loading agent details...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <EditHeader title='Edit Agent' agentName={agentnm} />

      <div className={styles.Maindiv}>
        <SectionHeader
          heading="Name & Avatar"
          subheading="Choose the Name, Looks & Greeting of your agent"
          highlight=""
        />
      </div>

      <div className={styles.container}>
        {isDataLoaded && (
          <SelectNameAvatar
            key={`${currentAvatar ?? "no-avatar"}-${currentName}-${currentRole}-${currentGreeting}-${isGender ?? "no-gender"}`}
            onValidationChange={handleValidationChange}
            originalAvatar={originalAvatarRef.current}
            originalName={originalNameRef.current}
            originalRole={originalRoleRef.current}
            originalGreeting={originalGreetingRef.current}
            businessName={businessNameRef.current}
            isGender={isGender}
          />
        )}

        <div
          className={styles.stickyWrapper}
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            padding: "8px",
            cursor: (stepValidation.isDirty && stepValidation.isValid) ? "pointer" : "not-allowed"
          }}
        >
          {/* Disabled state ki opacity sirf button par rakhni hai — wrapper par
              lagane se uska white background bhi see-through ho jaata tha aur
              greeting card bar ke peeche se jhaankta tha. */}
          <div
            style={{
              opacity: (stepValidation.isDirty && stepValidation.isValid) ? 1 : 0.5,
            }}
          >
            {/* relative — default "fixed" pe button wrapper se bahar nikal ke
                content (greeting cards) ke upar tairta tha. */}
            <AnimatedButton
              label="Save"
              isLoading={Loading}
              disabled={!stepValidation.isDirty || !stepValidation.isValid}
              onClick={(stepValidation.isDirty && stepValidation.isValid) ? handleClick : undefined}
              positionType="relative"
              width="100%"
              bottom="0px"
            />
          </div>
        </div>
      </div>

      {showPopup && (
        <PopUp
          type={popupType}
          onClose={() => setShowPopup(false)}
          message={popupMessage}
          onConfirm={() => {
            setShowPopup(false);
            if (popupType === "success") {
              const nextRoute = sessionStorage.getItem("nextEditRoute") || "/edit-agent-new";
              navigate(nextRoute);
            }
          }}
        />
      )}
    </div>
  );
}

export default EditNameAvtar;